<template>
  <ApiTable scene="enterprise_customer_info_v2" :params="params" @message="handleMessage" />
</template>
<script setup>
import { ref } from 'vue'
import ApiTable from '@/components/ApiTable/index.vue'
import { MessageBox } from '@qs/ui'
import { useRefreshBack, useRoute, useRouter } from '@/utils/useUtils'

const refreshBack = useRefreshBack()
const route = useRoute()
const router = useRouter()

const { id } = route.query

const params = ref({
  id,
})

const handleMessage = ({ cmd }) => {
  if (cmd === 'cancel') {
    MessageBox.confirm('取消后将返回列表，已填写内容将丢失，是否继续？', '确认取消', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    }).then(() => {
      refreshBack(false)
      router.push({
        path: '/driver/customerManage?type=company',
      })
    }).catch(() => null)
  }
}
</script>
